/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import CookieConsent from 'react-cookie-consent';

import type { Translate } from '../../types';

type Props = {
  t: Translate,
};

const CookieBanner = ({ t }: Props): React$Element<any> => {
  return (
    <CookieConsent
      location="bottom"
      acceptOnScroll={true}
      buttonText={t('I_CONSENT')}
      cookieName="CookieConsent"
      style={{ background: 'black', fontSize: '0.8em' }}
      buttonStyle={{ background: 'rgba(204, 0, 0, 0.7)', color: 'white' }}
    >
      {t('COOKIE_BANNER')}{' '}
      <a
        style={{ color: 'inherit', textDecoration: 'underline' }}
        href={'http://www.lacosa.it/privacy/'}
      >
        Cookie policy
      </a>
    </CookieConsent>
  );
};

export default withTranslation()(CookieBanner);
